import { IStrings } from './IStrings';
import { useContext } from 'react';
import { SpecificLocalizationContext } from './SpecificLocalizationContext';

export function useLocalization(): IStrings {
	return useContext(SpecificLocalizationContext).strings;
}
